// Angular
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { OffcanvasOptions } from '../../../../../core/_base/layout';

@Component({
	selector: 'kt-offcanvas-toolbar-notification',
	templateUrl: './offcanvas-toolbar-notification.component.html',
})
export class OffcanvasToolbarNotificationComponent implements OnInit {
	// Public properties
	offcanvasOptions: OffcanvasOptions = {
		overlay: true,
		baseClass: 'kt-offcanvas-panel',
		closeBy: 'kt_offcanvas_toolbar_notifications_close',
		toggleBy: 'kt_offcanvas_toolbar_notifications_toggler_btn'
	};
	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon: string = 'flaticon2-bell-alarm-symbol';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' = 'light';

	@Input() type: 'brand' | 'success' = 'success';
	count: number = 0;
	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(private sanitizer: DomSanitizer) {
	}
	ngOnInit(): void {

	}
	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}
}
